// HTTP CODES
export const HTTP_ERROR_FORBIDDEN: number = 403;

// APP CODES
export const APP_ERROR_TOKEN_EXPIRED: number = 4000;
export const APP_ERROR_FORBIDDEN: number = 4003;
export const APP_ERROR_PAYMENT_SUM = 5202;
